var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "video-collection-video-presenter p-2 text-white h-100",
      class: _vm.playing ? "active" : "",
      attrs: { href: _vm.videoCollectionVideo.url },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.handleClick($event)
        }
      }
    },
    [
      _c("img", {
        staticClass: "item__image",
        attrs: { src: _vm.videoCollectionVideo.imageUrl }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item__content d-flex py-3 align-items-start" },
        [
          _c("div", { staticClass: "d-block text-right item__indicator" }, [
            _c(
              "small",
              [
                _vm.playing
                  ? _c("VsIcon", { attrs: { icon: "md:play_arrow" } })
                  : [_vm._v(_vm._s(_vm.index + 1))]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item__title" }, [
            _vm._v(_vm._s(_vm.videoCollectionVideo.title))
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }